<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftDetail from '../../../../../shifts/components/ShiftDetail.vue'
import { ShiftID } from '../../../../../shifts/models/shift'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { id } = defineProps<{
  id: ShiftID
}>()
</script>

<template>
  <ShiftDetail :id="id" />
</template>
